// Animation configuration
export const ANIMATION_CONFIG = {
  // Durations (in seconds)
  duration: {
    fast: 0.2,
    normal: 0.3,
    slow: 0.5,
    verySlow: 0.8,
  },

  // Easings
  ease: {
    smooth: [0.4, 0, 0.2, 1],
    bounce: [0.68, -0.55, 0.265, 1.55],
    easeOut: [0, 0, 0.2, 1],
    easeIn: [0.4, 0, 1, 1],
  },

  // Spring configurations
  spring: {
    gentle: { stiffness: 120, damping: 14 },
    bouncy: { stiffness: 300, damping: 10 },
    stiff: { stiffness: 400, damping: 30 },
    slow: { stiffness: 100, damping: 20 },
  },

  // Stagger delays
  stagger: {
    fast: 0.05,
    normal: 0.1,
    slow: 0.15,
  },
} as const;

// Check if user prefers reduced motion
export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

// Get animation props based on reduced motion preference
export function getAnimationProps<T extends object>(
  animatedProps: T,
  staticProps: Partial<T> = {},
): T | Partial<T> {
  if (prefersReducedMotion()) {
    return staticProps;
  }
  return animatedProps;
}
